export const GET_PROPERTY_LISTING = "GET_PROPERTY_LISTING";
export const GET_PROPERTY_DETAIL = "GET_PROPERTY_DETAIL";
export const PROPERTY_FORM_DATA = "PROPERTY_FORM_DATA";
export const GET_CLIENT_CONTACT = "GET_CLIENT_CONTACT";
